<template src="../templates/bookingsHeaderRowComponent.html"></template>

<script>
	import {EventBus} from '../event-bus.js';
	
	export default {
        name: "BookingsHeaderRow",
        props: ["notClockedEarlyText"],
        methods: {
            onTickAllChanged() {
                this.$emit("onTickAllChanged", this.tickAll);
            },
			onSort(event) {
                let clickedButtonId = event.currentTarget.id;
                let keyStatusName = clickedButtonId + "SortedDirection";

                let sortKeys = Object.keys(this.sortStatuses);
                for (let index in sortKeys) {
                    if (sortKeys[index] !== keyStatusName) {
                        this.sortStatuses[sortKeys[index]] = "none";
                    }
                }
                let currentSortStatus = this.sortStatuses[keyStatusName];
                if (currentSortStatus === "none") {
                    this.sortStatuses[keyStatusName] = "desc";
                } else if (currentSortStatus === "asc") {
                    this.sortStatuses[keyStatusName] = "desc";
                } else {
                    this.sortStatuses[keyStatusName] = "asc";
                }

                this.$emit("onColumnSortChanged", event.currentTarget.id, this.sortStatuses[keyStatusName]);
            },
	        printData() {
		        this.$emit("printSelectedJob");
			}

        },
		mounted() {
        	let thisComponent = this;
			EventBus.$on('jobRowSelected', function (status) {
				console.log(status);
				console.log(thisComponent.counter);
				
				if (status) thisComponent.counter += 1;
				else {
					if ( thisComponent.counter >= 1 ) thisComponent.counter -= 1;
					else thisComponent.counter = 0;
				}
				
				console.log(thisComponent.counter)
				
				if ( thisComponent.counter > 0 ) thisComponent.tickSingle = true;
				else thisComponent.tickSingle = false;
			});
		},
        data() {
            return {
                tickAll: false,
                selectedButton: "",
                sortStatuses: {
                    locationSortedDirection: "none",
                    ref_numSortedDirection: "none",
                    languageSortedDirection: "none",
                    interpreter_nameSortedDirection: "none",
                    serviceDateSortedDirection: "asc",
                    serviceTimeStartSortedDirection: "none",
                    serviceTimeEndSortedDirection: "none",
                    requested_bySortedDirection: "none",
                },
				tickSingle: false,
	            counter: 0
            }
        }

    }
</script>

<style scoped lang="scss">

    @import '../assets/scss/general.scss';

</style>



// WEBPACK FOOTER //
// src/components/BookingsHeaderRowComponent.vue